const baseStyles = {
    background: {},
    sendButton: {},
    bubbles: {
        userBubble: {
            fontSize: "13px",
        },
        agentBubbleLink: {
            color: null,
        },
        agentBubble: {
            fontSize: "13px",
        },
    },
    avatar: {
        url: null,
        styles: {},
    },
};
export { baseStyles };
